import { Link } from "react-router-dom";
import Logo from "./Logo";
import { companyInfo, legalRoutes, footerLinks } from "@/content/legalContent";
import { useCookieConsentContext } from "@/contexts/CookieConsentContext";

const Footer = () => {
  const { openSettings } = useCookieConsentContext();

  return (
    <footer className="bg-white border-t" style={{ borderColor: "rgba(15,23,42,0.06)" }}>
      {/* Main footer grid */}
      <div className="max-w-[1080px] mx-auto px-6 pt-14 pb-10">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-10 sm:gap-8">
          {/* Produkt */}
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground/50 mb-4">
              Produkt
            </h3>
            <ul className="space-y-2.5">
              {footerLinks.product.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-xs text-muted-foreground/70 hover:text-foreground transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Företag */}
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground/50 mb-4">
              Företag
            </h3>
            <ul className="space-y-2.5">
              <li className="text-xs text-muted-foreground/70">{companyInfo.companyName}</li>
              <li className="text-xs text-muted-foreground/70">
                Org.nr {companyInfo.orgNumber}
              </li>
            </ul>
          </div>

          {/* Juridik */}
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground/50 mb-4">
              Juridik
            </h3>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-xs text-muted-foreground/70 hover:text-foreground transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  onClick={openSettings}
                  className="text-xs text-muted-foreground/70 hover:text-foreground transition-colors cursor-pointer bg-transparent border-none p-0 text-left"
                >
                  Cookieinställningar
                </button>
              </li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-widest text-muted-foreground/50 mb-4">
              Kontakt
            </h3>
            <ul className="space-y-2.5">
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="text-xs text-muted-foreground/70 hover:text-foreground transition-colors break-all"
                >
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom legal strip */}
      <div className="border-t border-border/20">
        <div className="max-w-[1080px] mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-muted-foreground/40 text-center sm:text-left">
            © {new Date().getFullYear()} {companyInfo.companyName}. Alla rättigheter förbehållna.
          </p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link
              to={legalRoutes.terms}
              className="text-[11px] text-muted-foreground/40 hover:text-muted-foreground transition-colors"
            >
              Användarvillkor
            </Link>
            <span className="text-muted-foreground/20 text-[11px]">|</span>
            <Link
              to={legalRoutes.privacy}
              className="text-[11px] text-muted-foreground/40 hover:text-muted-foreground transition-colors"
            >
              Integritetspolicy
            </Link>
            <span className="text-muted-foreground/20 text-[11px]">|</span>
            <Link
              to={legalRoutes.cookies}
              className="text-[11px] text-muted-foreground/40 hover:text-muted-foreground transition-colors"
            >
              Cookiepolicy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
